import { SafeHtmlContent } from '@yes.technology/react-toolkit'
import styled from 'styled-components'

type ActivitySafeHTMLProps = {
  htmlContent?: string
}

const TextAlignJustify = styled.div`
  text-align: justify;
`

const ActivitySafeHTML = ({ htmlContent }: ActivitySafeHTMLProps) => {
  return htmlContent ? (
    <TextAlignJustify>
      <SafeHtmlContent html={htmlContent} />
    </TextAlignJustify>
  ) : null
}

export default ActivitySafeHTML
